import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Amount, ApplicationState } from '@mews-commander/types';
import { ConvertedCurrencyValue } from '@mews-commander/ui';
import { getReservationsTotalAmount } from '@mews-commander/legacy-entities/src/selectors/orderItems';

interface StateProps {
    amount: Amount;
}
interface OwnProps {
    serviceOrderIds: string[];
    net: boolean;
}
type Props = StateProps & OwnProps;
const ReservationsTotalAmount = ({ amount, net }: Props) => <ConvertedCurrencyValue amount={amount} net={net} />;

export default connect<StateProps, {}, OwnProps, ApplicationState>(
    createStructuredSelector({ amount: getReservationsTotalAmount })
)(ReservationsTotalAmount);
